export default "__VITE_ASSET__96f00b8d__"